// pages/TenantSelect.js
import React, { useState } from "react";
import { useTenant } from "../context/TenantContext";

export default function TenantSelect() {
  const { available, selectTenant } = useTenant();
  const [busy, setBusy] = useState(null);
  const [error, setError] = useState(null);

  const choose = async (customerId) => {
    setError(null);
    setBusy(customerId);
    try {
      await selectTenant(customerId);
      // refresh() in selectTenant flips mustSelect → false, unmounting this gate.
    } catch (e) {
      setError("Could not select that customer. Please try again.");
      setBusy(null);
    }
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "100vh",
        gap: "1.5rem",
        padding: "2rem",
      }}
    >
      <div style={{ textAlign: "center" }}>
        <h1 style={{ fontSize: "1.5rem", fontWeight: 600 }}>Select a customer</h1>
        <p style={{ color: "#666", marginTop: "0.5rem" }}>
          Choose which customer's data to view.
        </p>
      </div>

      {error && <div style={{ color: "#c0392b" }}>{error}</div>}

      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "0.75rem",
          width: "100%",
          maxWidth: 360,
        }}
      >
        {available.map((c) => {
          const disabled = !c.schema_name || busy !== null;
          return (
            <button
              key={c.customer_id}
              onClick={() => choose(c.customer_id)}
              disabled={disabled}
              title={!c.schema_name ? "No data schema provisioned yet" : undefined}
              style={{
                padding: "0.9rem 1rem",
                borderRadius: 8,
                border: "1px solid #d0d0d0",
                background: disabled ? "#f3f3f3" : "#fff",
                cursor: disabled ? "not-allowed" : "pointer",
                textAlign: "left",
                fontSize: "1rem",
                opacity: c.schema_name ? 1 : 0.6,
              }}
            >
              <div style={{ fontWeight: 500 }}>{c.customer_name}</div>
              {!c.schema_name && (
                <div style={{ fontSize: "0.8rem", color: "#999" }}>
                  No data provisioned
                </div>
              )}
              {busy === c.customer_id && (
                <div style={{ fontSize: "0.8rem", color: "#666" }}>Loading…</div>
              )}
            </button>
          );
        })}
        {available.length === 0 && (
          <div style={{ color: "#666", textAlign: "center" }}>
            No customers are available to your account.
          </div>
        )}
      </div>
    </div>
  );
}
